const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path d="M3 1.5v21a1.5 1.5 0 0 0 3 0v-21a1.5 1.5 0 0 0-3 0Z" fill="currentColor"></path><path d="M8 14.85a1 1 0 0 0 .5.15 1 1 0 0 0 .5-.11l11.5-6a1 1 0 0 0 0-1.78L9 1.11A1 1 0 0 0 7.5 2v12a1 1 0 0 0 .5.85Z" fill="currentColor"></path></g></svg>';
export {
  a as default
};
